import React, { useReducer, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Formik, Form } from "formik";

// MUI Imports
import {
  Button,
  Dialog,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";

import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import UploadFileRoundedIcon from "@mui/icons-material/UploadFileRounded";
// import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";

// Project imports
import SectionSeven from "./SectionSeven";
import TextFieldTR from "../FormComponents/TextFieldTR";
import TCPopup from "./TCPopup";

import {
  openTcPopup,
  nextFormStep,
  closeTcPopup,
  previousFormStep,
  saveFormDataPartThree,
  registerTrainingCentre,
} from "../../../Actions";

import {
  initialState,
  formValidationSchema,
  reducer,
  BackButtonTR,
  SubmitButtonTR,
} from "./utils";

const PartThree = () => {
  const globalDispatch = useDispatch();
  const [state, dispatch] = useReducer(reducer, initialState);
  const [fieldValues, setFieldValues] = useState(null);
  const [cacUploaded, setCacUploaded] = useState(false);
  const [interiorPicUploaded, setInteriorPicUploaded] = useState(false);
  const [ownerPassportUploaded, setOwnerPassportUploaded] = useState(false);
  const [showCourseAssessmentErrors, setShowCourseAssessmentErrors] =
    useState(false);

  const trainingCentreRegReducer = (globalState) =>
    globalState.trainingCentreRegReducer;

  const {
    centerCapacity,
    commentOnConduciveness,
    commentOnDispute,
    commentOnCurriculum,
    commentOnImpact,
    otherInformation,

    courseContent,
    files,

    registeringTrainingCentre,
    trainingCentreRegComplete,
    trainingCentreRegError,

    // obviously unused - only for firing the API
    trainingTypeId,
    skillIds,
    skillCenterName,
    centerEmail,
    centerPhoneNumber,
    centerWhatsappNumber,
    stateId,
    localGovernmentId,
    physicalAddress,
    closeLandMark,

    trainers,
    equipments,
    tcPopupOpen,
    partThreeChangePageDirection,
  } = useSelector(trainingCentreRegReducer);

  const [formikInitialState] = useState({
    centerCapacity,
    commentOnConduciveness,
    commentOnDispute,

    commentOnCurriculum,
    commentOnImpact,
    otherInformation,
  });

  // sync local store
  useEffect(() => {
    const element = document.getElementById("treg-container");
    element.scrollIntoView({ behavior: "smooth" });

    dispatch({
      type: "syncLocalStore",
      body: {
        courseContent,
        files,
      },
    });
  }, []);

  useEffect(() => {
    console.log(state)
  }, [state])

  useEffect(() => {
    if (trainingCentreRegComplete === true) {
      if (trainingCentreRegError === true) {
      } else {
        globalDispatch(nextFormStep());
      }
    }
  }, [trainingCentreRegComplete]);

  function handleUserActions(type, body) {
    dispatch({
      type: type,
      body: body,
    });
  }

  function handleFileSelect(event, type) {
    const { files } = event.target;
    const fileName = files[0].name.split(".");
    const fileExtension = fileName[1];
    const fileReader = new FileReader();

    fileReader.onload = (e) => {
      const base64 = e.target.result;

      if (base64) {
        if (type === "uploadedCacCert") {
          setCacUploaded(true);
          dispatch({
            type: type,
            body: {
              file: base64,
              fileName: "CAC Certificate",
              fileExtension: `.${fileExtension}`,
              isOwnerPassport: false,
            },
          });
        } else if (type === "uploadedFile") {
          setInteriorPicUploaded(true);
          dispatch({
            type: type,
            body: {
              file: base64,
              fileName: `Interior Photograph`,
              fileExtension: `.${fileExtension}`,
              isOwnerPassport: false,
            },
          });
        } else if (type === "uploadedOwnerPassport") {
          setOwnerPassportUploaded(true);
          dispatch({
            type: type,
            body: {
              file: base64,
              fileName: `Owner Passport`,
              fileExtension: `.${fileExtension}`,
              isOwnerPassport: true,
            },
          });
        }
      }
    };

    fileReader.readAsDataURL(files[0]);
  }

  function handleDeleteCac() {
    setCacUploaded(false);
    dispatch({
      type: "removedUploadedCAC",
      body: state.cacCertFileName,
    });
  }

  function handleDeleteForOtherFiles(fileName) {
    setInteriorPicUploaded(false);
    dispatch({
      type: "removedOtherUploadedFiles",
      body: fileName,
    });
  }

  function handleFormSubmit(values) {
    if (state.courseContent.length < 1) {
      setShowCourseAssessmentErrors(true);
    } else {
      globalDispatch(
        saveFormDataPartThree({
          ...values,
          files: state.files,
        })
      );

      if (partThreeChangePageDirection === "next") {
        globalDispatch(openTcPopup());
        setFieldValues(values);
      } else if (partThreeChangePageDirection === "back") {
        globalDispatch(previousFormStep());
      }
      // console.log(values)
    }
  }

  // Under maintenance 🚧
  // function handleOpenViewUploadedFile() {
  //   dispatch({
  //     type: "openedFilePreview",
  //   });
  // }

  function handleCloseViewUploadedFile() {
    dispatch({
      type: "closedFilePreview",
    });
  }

  function handleCloseTcPopup() {
    globalDispatch(closeTcPopup());
  }

  function handleSubmitTcPopup() {
    const values = fieldValues;
    const bodyObj = {
      centerCapacity: values.centerCapacity,
      commentOnImpact: values.commentOnImpact,
      commentOnDispute: values.commentOnDispute,
      otherInformation: values.otherInformation,
      commentOnCurriculum: values.commentOnCurriculum,
      commentOnConduciveness: values.commentOnConduciveness,

      files: state.files,
      courseContent: state.courseContent,

      stateId: stateId,
      skillIds: skillIds,
      trainers: trainers,
      equipments: equipments,
      centerEmail: centerEmail,
      closeLandMark: closeLandMark,
      trainingTypeId: trainingTypeId,
      skillCenterName: skillCenterName,
      physicalAddress: physicalAddress,
      localGovernmentId: localGovernmentId,
      centerPhoneNumber: centerPhoneNumber,
      centerWhatsappNumber: centerWhatsappNumber,
    };

    globalDispatch(registerTrainingCentre(bodyObj));
  }

  // markups
  const sectionSixMarkup = [
    {
      type: "textField",
      name: "centerCapacity",
      label:
        "1. How many trainees can the centre comfortably take per training session?*",
    },
    {
      type: "textField",
      label:
        "2. Do you think the training centre is located in a conducive environment (emphasis on hygiene, security, space and ventilation) for the skill you are teaching? If yes, state justification. If no, state reason.*",
      multiline: true,
      name: "commentOnConduciveness",
    },
    {
      type: "textField",
      label:
        "3. How will your Centre resolve dispute and forestall future occurrences?*",
      multiline: true,
      name: "commentOnDispute",
    },
  ];

  // part of section 7 markup
  const courseAssessmentExtraMarkup = [
    {
      type: "textField",
      label:
        "b. Do you gaurantee that the training from your organization will be sufficient for a Corps member to start a business upon completion of the training? If yes state justification. If No state your reason *",
      multiline: true,
      name: "commentOnImpact",
    },
    {
      type: "textField",
      label:
        "c. Do you have a training curriculum for your skill areas(s)? If No why ?*",
      multiline: true,
      name: "commentOnCurriculum",
    },
  ];

  const otherInformationMarkup = {
    type: "textField",
    label: "4. Kindly input any other information you feel is important*",
    name: "otherInformation",
    multiline: true,
  };

  return (
    <>
      <Formik
        initialValues={{
          ...formikInitialState,
        }}
        validationSchema={formValidationSchema}
        onSubmit={handleFormSubmit}
      >
        <Form>
          {/* Section 6 */}
          <Grid item xs container direction={"column"} id="section-six-header">
            <h2>Section 6</h2>
            <p>Assessment of Training Environment</p>
            <Grid container direction={"column"} spacing={"1.5 rem"}>
              {sectionSixMarkup.map((field, index) => (
                <Grid item xs key={index}>
                  {field.type === "textField" && (
                    <TextFieldTR
                      label={field.label}
                      name={field.name}
                      multiline={field.multiline}
                    />
                  )}
                </Grid>
              ))}
            </Grid>
          </Grid>

          {/* Section 7 */}
          <SectionSeven
            courseContent={state.courseContent}
            dispatch={dispatch}
            handleUserActions={handleUserActions}
            showCourseAssessmentErrors={showCourseAssessmentErrors}
            setShowCourseAssessmentErrors={setShowCourseAssessmentErrors}
          />

          {/* Questions  b & c */}
          <Grid
            item
            xs
            container
            direction={"column"}
            spacing={"2rem"}
            style={{ marginTop: "1rem" }}
          >
            {courseAssessmentExtraMarkup.map((field, index) => (
              <Grid item xs key={index}>
                {field.type === "textField" && (
                  <TextFieldTR
                    label={field.label}
                    name={field.name}
                    multiline={field.multiline}
                  />
                )}
              </Grid>
            ))}
          </Grid>

          {/* Section 8 */}
          <Grid
            item
            xs
            container
            direction={"column"}
            style={{
              paddingTop: "2rem",
            }}
          >
            <h2>Section 8</h2>

            <Grid
              item
              xs
              container
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <p style={{ marginTop: "1rem" }}>
                1. CAC Business Registration Certificate*
              </p>

              {!state.files.find((file) => file?.fileName === "CAC Certificate") || !cacUploaded ? (
                <Button
                  variant={"outlined"}
                  component="label"
                  sx={{ maxWidth: "fit-content", margin: "1rem 0 1.5rem 0" }}
                  startIcon={
                    <UploadFileRoundedIcon sx={{ color: "#137542" }} />
                  }
                >
                  Upload CAC
                  <input
                    hidden
                    type="file"
                    accept="image/*"
                    id="uploadedReceipt"
                    onChange={(event) =>
                      handleFileSelect(event, "uploadedCacCert")
                    }
                  />
                </Button>
              ) : (
                <Grid
                  item
                  xs
                  container
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    border: "1px solid lightgrey",
                    marginTop: "1rem",
                    width: "fit-content",
                    padding: "0 1rem",
                    borderRadius: "7px",
                  }}
                >
                  <p style={{ paddingTop: ".5rem" }}>CAC Certificate</p>

                  <div>
                    <IconButton
                      color="error"
                      onClick={handleDeleteCac}
                      style={{ marginLeft: "1rem" }}
                    >
                      <DeleteOutlineRoundedIcon />
                    </IconButton>
                    {/* <IconButton
                      onClick={handleOpenViewUploadedFile}
                      color="primary"
                    >
                      <VisibilityOutlinedIcon />
                    </IconButton> */}
                  </div>
                </Grid>
              )}
            </Grid>

            <Grid
              item
              xs
              container
              style={{ display: "flex", flexDirection: "column" }}
            >
              <p style={{ marginTop: "1rem" }}>
                2. Interior Photograph of Training Center*
              </p>

              {!state.files.find(
                (file) => file?.fileName === "Interior Photograph"
              ) ? (
                <Button
                  variant={"outlined"}
                  component="label"
                  sx={{ maxWidth: "fit-content", margin: "1rem 0 1.5rem 0" }}
                  startIcon={
                    <UploadFileRoundedIcon sx={{ color: "#137542" }} />
                  }
                >
                  Upload Photograph
                  <input
                    hidden
                    type="file"
                    id="uploadedReceipt"
                    onChange={(event) =>
                      handleFileSelect(event, "uploadedFile")
                    }
                  />
                </Button>
              ) : (
                <Grid item xs container direction={"row"}>
                  {state.files
                    .filter((file) => file.fileName === "Interior Photograph")
                    ?.map((file) => (
                      <div
                        key={file.fileName}
                        style={{
                          padding: "0 8px",
                          marginRight: "8px",
                          marginBottom: "8px",
                          marginTop: "8px",
                          border: "1px solid lightgrey",
                          borderRadius: "6px",
                        }}
                      >
                        {file.fileName}
                        {file.fileExtension}

                        <IconButton
                          color="error"
                          onClick={() =>
                            handleDeleteForOtherFiles(file.fileName)
                          }
                          style={{ marginLeft: ".5rem" }}
                        >
                          <DeleteOutlineRoundedIcon />
                        </IconButton>
                      </div>
                    ))}
                </Grid>
              )}
            </Grid>

            <Grid
              item
              xs
              container
              style={{ display: "flex", flexDirection: "column" }}
            >
              <p style={{ marginTop: "1rem" }}>
                3. Business Owner Passport Photograph*
              </p>

              {!state.files.find((file) => file?.fileName === "Owner Passport") ? (
                <Button
                  variant={"outlined"}
                  component="label"
                  sx={{ maxWidth: "fit-content", margin: "1rem 0 1.5rem 0" }}
                  startIcon={
                    <UploadFileRoundedIcon sx={{ color: "#137542" }} />
                  }
                >
                  Upload Business Owner Passport
                  <input
                    hidden
                    type="file"
                    id="uploadedReceipt"
                    onChange={(event) =>
                      handleFileSelect(event, "uploadedOwnerPassport")
                    }
                  />
                </Button>
              ) : (
                <Grid item xs container direction={"row"}>
                  {state.files
                    .filter((file) => file.fileName === "Owner Passport")
                    ?.map((file) => (
                      <div
                        key={file.fileName}
                        style={{
                          padding: "0 8px",
                          marginRight: "8px",
                          marginBottom: "8px",
                          marginTop: "8px",
                          border: "1px solid lightgrey",
                          borderRadius: "6px",
                        }}
                      >
                        {file.fileName}
                        {file.fileExtension}

                        <IconButton
                          color="error"
                          onClick={() =>
                            handleDeleteForOtherFiles(file.fileName)
                          }
                          style={{ marginLeft: ".5rem" }}
                        >
                          <DeleteOutlineRoundedIcon />
                        </IconButton>
                      </div>
                    ))}
                </Grid>
              )}
            </Grid>

            <TextFieldTR
              label={otherInformationMarkup.label}
              name={otherInformationMarkup.name}
              multiline={otherInformationMarkup.multiline}
            />
          </Grid>

          {/* Preview uploaded images dialog component - under maintenance🚧 */}
          <Dialog
            open={state.filePreviewIsOpen}
            onClose={handleCloseViewUploadedFile}
          >
            <DialogTitle
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <Typography variant="body">Preview</Typography>
              <IconButton onClick={handleCloseViewUploadedFile}>
                <CloseRoundedIcon />
              </IconButton>
            </DialogTitle>
            <img
              src={
                "data:image/webp;base64,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"
              }
              alt="Preview Document"
            />
          </Dialog>

          {/* Submit button */}
          <Grid
            item
            xs
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "3rem",
            }}
          >
            <BackButtonTR>Back</BackButtonTR>
            <SubmitButtonTR disabled={registeringTrainingCentre || state.files.length < 3 }>
              Complete Registration
            </SubmitButtonTR>
          </Grid>
        </Form>
      </Formik>
      <TCPopup
        open={tcPopupOpen}
        handleClose={handleCloseTcPopup}
        handleSubmit={handleSubmitTcPopup}
        isLoading={registeringTrainingCentre}
      />
    </>
  );
};

export default PartThree;
